import { render, staticRenderFns } from "./virtusHomeClubCard.vue?vue&type=template&id=0bfd8d5e&"
import script from "./virtusHomeClubCard.vue?vue&type=script&lang=js&"
export * from "./virtusHomeClubCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports